import { createSelector } from 'reselect';

import { rsSelector } from '../root/rsSelector';

export const projectNameSelector = createSelector(rsSelector, rs => rs.projectName);
